/**
 * Sticky Bar
 * 
 * @Author: Focci
 * @Date: 2023-08-11 10:55:43
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-11 10:55:43
 */

'use client'

// import PropTypes from 'prop-types'
import clsx from 'clsx'
import { isWindow } from '@lib/utils'
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react'

function StickyBar({
  top = 0,
  target, // 容器
  resident = false, // true 会一直显示，不会随着滚动隐藏
  className = '',
  children
}, ref) {
  const wrapper = useRef()
  const [show, setShow] = useState(resident)

  const handleScroll = useCallback(() => {
    if(!wrapper.current) return
    
    const { top: t } = wrapper.current.getBoundingClientRect()
    setShow(t <= top)
  }, [top])

  useEffect(() => {
    if(!isWindow || resident) return () => {}
    const targetEl = target || window

    handleScroll()
    targetEl.addEventListener('scroll', handleScroll, false)

    return () => {
      targetEl.removeEventListener('scroll', handleScroll, false)
    }
  }, [handleScroll, resident, target])

  useImperativeHandle(ref, () => ({
    getEl: () => wrapper.current,
  }))

  return (
    <div 
      ref={wrapper} 
      className={clsx(['sticky z-[100]', className])}
      style={{ top: `${top}px` }}
    >
      {show && children}
    </div>
  )
}

export default forwardRef(StickyBar)

// StickyBar.propTypes = {
//   top: PropTypes.number,
//   target: PropTypes.node,
//   resident: PropTypes.bool,
//   className: PropTypes.string,
//   children: PropTypes.node,
// }
